/**
 * Computes a SHA-256 hash of an ArrayBuffer and returns it as a lowercase hex string.
 */
export async function computeSHA256(content: ArrayBuffer): Promise<string> {
  const hashBuffer = await crypto.subtle.digest('SHA-256', content);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
}

/**
 * Reads a File's bytes and returns its SHA-256 hash as a lowercase hex string.
 */
export async function computeFileHash(file: File): Promise<string> {
  const buffer = await file.arrayBuffer();
  return computeSHA256(buffer);
}
